import React, { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useActiveComponent } from '../../Components/ActiveComponentContext.js';
import { useAuth } from '../../contexts/AuthContext/index.jsx';
import { db } from '../../Firebase/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { Box, Typography, Tab, Tabs, Tooltip } from '@mui/material';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import LinkIcon from '@mui/icons-material/Link';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import EditProfileDialog from '../../Components/EditProfileDialog/index.jsx';
import SearchBar from '../../Components/SearchBar/index.jsx';

const Dashboard = () => {
  const {
    loading,
    setLoading,
    mySavedPostsLength,
    userPosts,
    userPostsLength,
    currentUser,
    setCurrentUser,
    setUserProfile,
    displayName,
    username,
    userBio,
    userLink,
    setDisplayName,
    setUsersname,
    setUserBio,
    setUserLink,
    updateUserProfile,
    updateUserImage,
    //mySavedPosts,
    //userData,
  } = useAuth();
  const [posts, setPosts] = useState(userPosts);
  const { backgroundColor } = useActiveComponent();
  const [anchorEl, setAnchorEl] = useState(null); // State for the menu anchor
  const [openEditDialog, setOpenEditDialog] = useState(false);
  // State for the second dropdown (EditIcon)
  const [anchorElEdit, setAnchorElEdit] = useState(null);
  const open = Boolean(anchorEl); // Determine if the menu is open
  const openEditMenu = Boolean(anchorElEdit);
  //  const[displayName, setDisplayName] = useState(currentUser.displayName || "")
  //  const [savedPosts, setSavedPosts] = useState([]); // State for saved posts

  const gmailEmail = currentUser?.providerData?.find(
    (provider) => provider.providerId === 'google.com'
  )?.email;
  if (!gmailEmail) {
    console.error('No Gmail email found for the current user.');
  }

  // Fetch user data from Firebase and set it in the context
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const user = currentUser; // const user = auth.currentUser;
        if (!user) {
          console.error('No current user found.');
          return; // Exit early if no user
        }
        const userRef = doc(db, 'users', user.uid); //user curentUser's user uid as a doc reference in 'users'
        const docSnapshot = await getDoc(userRef); //use reference to retrieve user's docs in firebase
        if (docSnapshot.exists()) {
          const userData = docSnapshot.data(); //snapshot of user's data in firebase
          // Update all states via setUserProfile
          setUserProfile({
            displayName: userData.displayName || '',
            username: userData.username || '',
            userBio: userData.bio || '',
            userLink: userData.link || '',
            profileImage: userData.profileImage || '',
            bannerImage: userData.bannerImage || '',
          });
        } else {
          console.warn('User document does not exist.');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setLoading(false); // Ensure loading is stopped even if an error occurs
      }
    };

    if (currentUser) {
      fetchUserData(); // Only call when currentUser is valid
    }
  }, [currentUser]);

  // Function to update posts
  const updatePost = (updatedPost) => {
    setPosts((prevPosts) =>
      prevPosts.map((post) => (post.id === updatedPost.id ? updatedPost : post))
    );
  };

  const handleEditProfileClick = () => {
    setOpenEditDialog(true); // Open the dialog
    handleEditMenuClose(); // Close the menu
  };

  const handleDialogClose = () => {
    setOpenEditDialog(false); // Close the dialog
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget); // Set the anchor element to the button
  };

  const handleClose = () => {
    setAnchorEl(null); // Close the menu
  };

  const handleOptionClick = (option) => {
    // Handle the option click (e.g., change profile pic or banner image)
    // console.log(option); // Replace with your logic
    handleClose(); // Close the menu after an option is clicked
  };

  const handleEditMenuClick = (event) => {
    setAnchorElEdit(event.currentTarget);
  };

  const handleEditMenuClose = () => {
    setAnchorElEdit(null);
  };

  const fontColor = backgroundColor === '#ffffff' ? '#030202' : 'lightgrey';

  const navigate = useNavigate();

  useEffect(() => {
    setPosts(userPosts); // Update posts whenever userPosts changes
  }, [userPosts]);

  if (!currentUser) {
    return <Typography>You need to log in to see your dashboard.</Typography>;
  }

  return (
    <>
      <Box
        sx={{
          height: '100vh', // Full viewport height
          //overflowY: 'hidden', // Disable vertical scrolling of entire homepage
          //overflowY: 'auto', // Disable vertical scrolling of entire homepage
          //position: 'sticky',
        }}
      >
        {/* Sticky header section with Typography and Tabs */}
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1000, // Ensure it's above other content while scrolling
            backgroundColor: backgroundColor, // Set background so it's visible while scrolling
            p: 0.5,
          }}
        >
          <Box
            sx={{
              display: { xs: 'flex', sm: 'flex', lg: 'none', xl: 'none' },
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'white',
              pb: 0.5,
              height: 45,
              ml: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
              position: 'sticky',
              top: 0,
              zIndex: 1000, // Ensure it's above other content while scrolling
              mb: 2,
            }}
          >
            <SearchBar width={300} />
          </Box>
          {/* <Box position='relative'> */}
          <Box
            component='img'
            src={
              currentUser.bannerImage ||
              '../images/siteImages/dashboardDesign.png'
            }
            alt='dashboard-image'
            sx={{
              width: {
                xs: 330,
                sm: 330,
                md: 360,
                lg: 1300,
                xl: 1300,
              },
              objectFit: 'cover',
              height: {
                xs: '80px',
                sm: '90px',
                md: '110px',
                lg: '120px',
                xl: '120px',
              },
              borderRadius: '14px',
              display: 'block',
              margin: 'auto',
              borderRadius: 4,
              mt: 0,
              mb: 1,
              backgroundRepeat: 'repeat-x',
            }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 1,
              alignItems: 'center',
              width: { xs: '90%' },
              mr: 'auto',
              ml: 'auto',
            }}
          >
            <Avatar
              src={
                currentUser.photo ||
                currentUser.photoURL ||
                '../images/siteImages/defaultAvatar.jpg'
              }
              alt='User Avatar'
              sx={{
                width: { xs: 80, sm: 80, md: 110, lg: 120, xl: 120 },
                height: { xs: 80, sm: 80, md: 110, lg: 120, xl: 120 },
              }}
            />
            {/* <Grid item xs={12} sm={4} md={4} lg={4} xl={4}> */}
            <Box
              sx={{
                width: { xs: 300, sm: 300, md: 800, lg: 1200, xl: 1200 },
                p: 0,
                zIndex: 500,
                mt: 0,
              }}
            >
              {/* Profile and Edit button Title */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-end',
                  pr: 0,
                }}
              >
                <Typography
                  variant='h6'
                  sx={{
                    pl: 1,
                    pt: 0,
                    mb: { xs: 0, sm: 0, md: 0, lg: 1, xl: 1 },
                    fontFamily: 'Montserrat',
                    fontWeight: 600,
                    fontSize: { xs: 11, sm: 11, md: 12, lg: 16, xl: 16 },
                  }}
                >
                  Profile
                </Typography>
                <Tooltip title='Edit Profile'>
                  <IconButton onClick={handleEditMenuClick}>
                    <EditIcon
                      sx={{
                        color: 'black',
                        fontSize: { xs: 12, sm: 12, md: 14, lg: 18, xl: 18 },
                        mb: { xs: -0.5, sm: 0, md: 0, lg: 1, xl: 1 },
                      }}
                    />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ borderRadius: 10 }}
                  id='edit-menu'
                  anchorEl={anchorElEdit}
                  open={openEditMenu}
                  onClose={handleEditMenuClose}
                  MenuListProps={{
                    'aria-labelledby': 'edit-button',
                  }}
                >
                  <MenuItem
                    sx={{
                      fontSize: { xs: 10, sm: 10, md: 10, lg: 13, xl: 13 },
                      fontFamily: 'Montserrat',
                    }}
                    onClick={handleEditProfileClick}
                  >
                    Edit Profile
                  </MenuItem>
                </Menu>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  gap: { xs: 0, sm: 0, md: 1, lg: 6, xl: 6 },
                }}
              >
                {/* Profile Info */}
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ display: 'flex', pl: 0, alignItems: 'center' }}>
                    <IconButton>
                      <AccountCircleIcon
                        sx={{
                          color: 'black',
                          fontSize: { xs: 11, sm: 11, md: 12, lg: 16, xl: 16 },
                        }}
                      />
                    </IconButton>
                    <Typography
                      variant='body1'
                      sx={{
                        p: 1,
                        fontFamily: 'Montserrat',
                        fontSize: { xs: 9, sm: 9, md: 11, lg: 13, xl: 13 },
                        ml: -1,
                      }}
                    >
                      {loading ? (
                        <CircularProgress size={20} />
                      ) : (
                        displayName || 'N/A'
                      )}
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', pl: 0, alignItems: 'center' }}>
                    <IconButton>
                      <AlternateEmailIcon
                        sx={{
                          color: 'black',
                          fontSize: { xs: 11, sm: 11, md: 12, lg: 16, xl: 16 },
                        }}
                      />
                    </IconButton>
                    <Typography
                      variant='body1'
                      sx={{
                        p: 1,
                        fontFamily: 'Montserrat',
                        fontSize: { xs: 9, sm: 9, md: 11, lg: 13, xl: 13 },
                        ml: -1,
                      }}
                    >
                      {loading ? (
                        <CircularProgress size={20} />
                      ) : (
                        username || 'N/A'
                      )}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton>
                      <LinkIcon
                        sx={{
                          color: 'black',
                          fontSize: { xs: 11, sm: 11, md: 12, lg: 16, xl: 16 },
                          transform: 'rotate(-45deg)',
                        }}
                      />
                    </IconButton>

                    {userLink ? (
                      <Typography
                        variant='body1'
                        fontFamily='Montserrat'
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          fontSize: {
                            xs: 9,
                            sm: 9,
                            md: 11,
                            lg: 13,
                            xl: 13,
                          },
                        }}
                      >
                        <a
                          href={
                            userLink.startsWith('http://') ||
                            userLink.startsWith('https://')
                              ? userLink
                              : `https://${userLink}`
                          }
                          target='_blank'
                          rel='noopener noreferrer'
                          style={{ color: 'blue', fontStyle: 'italic' }}
                        >
                          {userLink || 'N/A'}
                        </a>
                      </Typography>
                    ) : (
                      <Typography
                        variant='body1'
                        sx={{
                          p: 1,
                          fontFamily: 'Montserrat',
                          fontSize: { xs: 9, sm: 9, md: 11, lg: 13, xl: 13 },
                        }}
                      >
                        Insert link
                      </Typography>
                    )}
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography
                      variant='h6'
                      sx={{
                        p: 1,
                        pt: 1.2,
                        fontFamily: 'Montserrat',
                        fontWeight: 600,
                        fontSize: { xs: 9, sm: 9, md: 11, lg: 13, xl: 13 },
                      }}
                    >
                      Bio:
                    </Typography>
                    <Typography
                      variant='body1'
                      sx={{
                        p: 1,
                        pl: 0,
                        pt: 1.2,
                        fontFamily: 'Montserrat',
                        maxWidth: {
                          xs: 100,
                          sm: 100,
                          md: 200,
                          lg: 500,
                          xl: 500,
                        },
                        fontSize: { xs: 9, sm: 9, md: 11, lg: 13, xl: 13 },
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 1, // Limit to 2 lines
                        '&:after': {
                          content: '"..."',
                          display: 'inline',
                          color: 'gray',
                        },
                      }}
                    >
                      {loading ? (
                        <CircularProgress size={20} />
                      ) : (
                        userBio || 'N/A'
                        // "this is a long ass bio just to see what it looks like"
                      )}
                    </Typography>
                  </Box>
                  <EditProfileDialog
                    openEditDialog={openEditDialog}
                    handleDialogClose={handleDialogClose}
                    currentUser={currentUser}
                    setCurrentUser={setCurrentUser}
                    userDisplayName={displayName}
                    username={username}
                    userEmail={gmailEmail || currentUser?.email}
                    userLink={userLink}
                    userBio={userBio}
                    setDisplayName={setDisplayName}
                    setUsersname={setUsersname}
                    setUserBio={setUserBio}
                    setUserLink={setUserLink}
                    updateUserProfile={updateUserProfile}
                    updateUserImage={updateUserImage}
                    // userBio={currentUser.bio || ''}
                    // userLink={currentUser.link || ''}
                    // userDisplayName={currentUser.displayName}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* <Box></Box> */}

        {/* ENtire bottom section */}
        <Box
          sx={{
            display: 'flex',
            mt: 1,
            position: 'sticky',
            height: 'auto',
          }}
        >
          <Box
            sx={{
              height: '60vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              overflowY: 'auto',
              width: {
                xs: '100%',
                sm: '100%',
                md: '100%',
                lg: '100%',
                xl: '100%',
              },
              ml: 'auto',
              mr: 'auto',
              pl: 'auto',
              pr: 'auto',
              boxSizing: 'border-box',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                backgroundColor: 'rgb(230,230,230,0.6)',
                borderRadius: 3,
                boxShadow: '0px 1px 1px inset grey',
                mb: 1.5,
                width: {
                  xs: '80%',
                  sm: '80%',
                  md: '60%',
                  lg: '50%',
                  xl: '50%',
                },
                ml: 'auto',
                mr: 'auto',
                pl: 0.25,
                pr: 0.25,
                zIndex: 1000,
              }}
            >
              <Tabs
                value={window.location.pathname.includes('/savedposts') ? 1 : 0}
                aria-label='Dashboard Navigation Tabs'
                sx={{
                  width: '100%', // Ensure the Tabs take up the full width of the parent Box
                  display: 'flex',
                  justifyContent: 'space-between', // Distribute space evenly
                  '& .MuiTabs-indicator': {
                    backgroundColor: 'transparent', // Remove default indicator color
                  },
                  '& .Mui-selected': {
                    backgroundColor: 'white', // Set background for selected tab
                    boxShadow: '0px 2px 2px  grey',
                    borderRadius: 3, // Apply border radius
                  },
                  // '& .MuiTab-root': {
                  //   color: 'black', // Set text color for non-selected tabs
                  // },
                }}
              >
                <Tab
                  disableRipple
                  sx={{
                    flex: 1, // Make each tab take equal space
                    fontSize: { xs: 10, sm: 10, md: 14, lg: 14, xl: 14 }, // Responsive font size
                    m: 0.25,
                    width: '100%',
                    fontFamily: 'Montserrat',
                    whiteSpace: 'nowrap', // Prevent text from splitting into a new line
                    '&.Mui-selected': {
                      backgroundColor: 'white',
                    },
                  }}
                  label={`My Posts (${userPostsLength})`}
                  component={NavLink}
                  to='/dashboard/myposts'
                />
                <Tab
                  disableRipple
                  sx={{
                    flex: 1, // Make each tab take equal space
                    fontSize: { xs: 10, sm: 10, md: 14, lg: 14, xl: 14 }, // Responsive font size
                    m: 0.25,
                    width: '100%',
                    fontFamily: 'Montserrat',
                    whiteSpace: 'nowrap', // Prevent text from splitting into a new line
                    '&.Mui-selected': {
                      backgroundColor: 'white',
                    },
                  }}
                  label={`Saved (${mySavedPostsLength})`}
                  component={NavLink}
                  to='/dashboard/savedposts'
                />
              </Tabs>
            </Box>
            <Box
              sx={{
                overflowY: 'auto',
                display: 'flex',
                boxSizing: 'border-box',
                justifyContent: 'center',
              }}
            >
              <Outlet
                context={{
                  posts,
                  setPosts,
                  updatePost, // Pass down update function
                }}
              />
            </Box>

            {/* </Grid> */}
          </Box>
          {/* </Grid> */}
        </Box>
      </Box>
    </>
  );
};

export default Dashboard;

//previous setup:
{
  /* Profile  info section */
}
{
  /* <Grid container spacing={0}> */
}
{
  /* Grid at bottom with actual posts */
}
{
  /* <Grid
              item
              xs={12}
              sm={8}
              md={8}
              lg={8}
              xl={8}
              sx={{
                height: '60vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                overflowY: 'auto',
                border:'2px solid black',
                width:'100%'
              }}
            > */
}
{
  /* <Box sx={{ display: 'flex', pl: 2 }}>
                  <IconButton>
                    <ContactMailIcon sx={{ color: 'black' }} />
                  </IconButton>
                  <Typography
                    variant='body1'
                    sx={{
                      p: 1.8,
                      fontFamily: 'Montserrat',
                    }}
                  >
                    {loading ? (
                      <CircularProgress size={20} />
                    ) : (
                      currentUser.email || gmailEmail || 'NA'
                    )}
                  </Typography>
                </Box> */
}
{
  /* <Box sx={{ display: 'flex', pl: 2 }}>
                  <IconButton>
                    <LinkIcon sx={{ color: 'black' }} />
                  </IconButton>
                 
                  {userLink ? (
                    <NavLink to='/your-link'>
                      <Typography
                        variant='body1'
                        sx={{
                          p: 1.8,
                          fontFamily: 'Montserrat',
                        }}
                      >
                        {loading ? (
                          <CircularProgress size={20} />
                        ) : (
                          userLink || 'N/A'
                        )}
                      </Typography>
                    </NavLink>
                  ) : (
                    <Typography
                      variant='body1'
                      sx={{
                        p: 1.8,
                        fontFamily: 'Montserrat',
                      }}
                    >
                      Insert your link of choice
                    </Typography>
                  )}
                </Box> */
}

{
  /* Account Section */
}
{
  /* <Box sx={{ display: 'flex' }}>
                  <Typography
                    variant='h6'
                    sx={{
                      pl: 3,
                      pt: 1.8,
                      fontFamily: 'Montserrat',
                      fontWeight: 600,
                    }}
                  >
                    Bio
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', pl: 1 }}>
                  <Typography
                    variant='body1'
                    sx={{
                      p: 1.8,
                      pl: 2,
                      fontFamily: 'Montserrat',
                    }}
                  >
                    {loading ? (
                      <CircularProgress size={20} />
                    ) : (
                      userBio || 'N/A'
                    )}
                  </Typography>
                </Box>
                <EditProfileDialog
                  openEditDialog={openEditDialog}
                  handleDialogClose={handleDialogClose}
                  currentUser={currentUser}
                  setCurrentUser={setCurrentUser}
                  // userDisplayName={currentUser.displayName}
                  userDisplayName={displayName}
                  username={username}
                  userEmail={gmailEmail || currentUser?.email}
                  // userLink={currentUser.link || ''}
                  userLink={userLink}
                  // userBio={currentUser.bio || ''}
                  userBio={userBio}
                  setDisplayName={setDisplayName}
                  setUsersname={setUsersname}
                  setUserBio={setUserBio}
                  setUserLink={setUserLink}
                  updateUserProfile={updateUserProfile}
                  updateUserImage={updateUserImage}
                /> */
}

{
  /* <IconButton
              sx={{
                position: 'absolute',
                bottom: 35,
                left: 186,
              }}
              onClick={handleMenuClick}
            >
              <PhotoCameraIcon
                sx={{
                  color: 'black',
                  backgroundColor: 'rgba(240, 240, 240, 0.6)',
                  borderRadius: '50%',
                  fontSize: '18px',
                  p: 0.5,
                }}
              />
            </IconButton>
            <Menu
              sx={{ borderRadius: 10, ml: 2 }}
              id='basic-menu'
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem
                sx={{ fontSize: 13, fontFamily: 'Montserrat' }}
                onClick={() => handleOptionClick('Change Profile Pic')}
              >
                Change Pic
              </MenuItem>
              <MenuItem
                sx={{ fontSize: 13, fontFamily: 'Montserrat' }}
                onClick={() => handleOptionClick('Change Banner Image')}
              >
                Change Banner
              </MenuItem>
            </Menu> */
}
